import { useEffect, useState } from 'react';

import RegExps from '../../../../data/RegExps';
import ValidationError from '../../../utils/validation/ValidationError';
import Validator from '../../../utils/validation/Validator';
import { PasswordValidationHook } from './types';

const usePasswordValidation: PasswordValidationHook = (password) => {
	const [isWithinMinLimit, setIsWithinMinLimit] = useState(false);
	const [isIncludesLowercase, setIsIncludesLowercase] = useState(false);
	const [isIncludesUppercase, setIsIncludesUppercase] = useState(false);
	const [isIncludesNumber, setIsIncludesNumber] = useState(false);
	const [isIncludesSpecialChar, setIsIncludesSpecialChar] = useState(false);

	useEffect(() => {
		const validatedPassword = new Validator(password, 'Password');

		try {
			validatedPassword.isWithinMinLimit(8);

			setIsWithinMinLimit(true);
		} catch (error) {
			if (error instanceof ValidationError) {
				setIsWithinMinLimit(false);
			}
		}

		try {
			validatedPassword.isMatchesRegExp(RegExps.positiveLookaheadFor.lowercase);

			setIsIncludesLowercase(true);
		} catch (error) {
			if (error instanceof ValidationError) {
				setIsIncludesLowercase(false);
			}
		}

		try {
			validatedPassword.isMatchesRegExp(RegExps.positiveLookaheadFor.uppercase);

			setIsIncludesUppercase(true);
		} catch (error) {
			if (error instanceof ValidationError) {
				setIsIncludesUppercase(false);
			}
		}

		try {
			validatedPassword.isMatchesRegExp(RegExps.positiveLookaheadFor.number);

			setIsIncludesNumber(true);
		} catch (error) {
			if (error instanceof ValidationError) {
				setIsIncludesNumber(false);
			}
		}

		try {
			validatedPassword.isMatchesRegExp(
				RegExps.positiveLookaheadFor.specialChar
			);

			setIsIncludesSpecialChar(true);
		} catch (error) {
			if (error instanceof ValidationError) {
				setIsIncludesSpecialChar(false);
			}
		}
	}, [password]);

	return {
		isWithinMinLimit,
		isIncludesLowercase,
		isIncludesUppercase,
		isIncludesNumber,
		isIncludesSpecialChar,
	};
};

export default usePasswordValidation;
